import { ExamEventExamineeStatus, ExamineeRegistrationStatus } from '@exam-center/graphql';

/**
 * Derives the status an examinee would be reinstated to, based on backend logic.
 * Returns null if reinstate is not allowed (exam session already started → would become InProgress).
 *
 * Logic mirrors backend reinstate flow: PREPARE_FOR_EXAM → REGISTERED → null (IN_PROGRESS)
 * - registrationStatus !== REGISTERED → PrepareForExam
 * - registrationStatus === REGISTERED AND any session has started → null (not allowed)
 * - registrationStatus === REGISTERED AND no session has started → Registered
 */
export function getReinstatedStatus(
  registrationStatus: ExamineeRegistrationStatus,
  examStartedAtList: (Date | string | null)[],
): ExamEventExamineeStatus.Registered | ExamEventExamineeStatus.PrepareForExam | null {
  if (registrationStatus !== ExamineeRegistrationStatus.Registered) {
    return ExamEventExamineeStatus.PrepareForExam;
  }
  const hasStarted = examStartedAtList.some((v) => v !== null);
  if (hasStarted) return null;
  return ExamEventExamineeStatus.Registered;
}
